// extracted by mini-css-extract-plugin
export var fullHeightState = "_2b-7";
export var headerCell = "_2b-1";
export var loadingStateCell = "_2b-4";
export var rowWrapper = "_2b-3";
export var standaloneTable = "_2b-8";
export var standaloneTableWithBodyFill = "_2b-9";
export var stateCell = "_2b-5";
export var table = "_2b-0";
export var tableBodyFiller = "_2b-6";
export var white = "_2b-2";